import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { PinataPage, pinataMeta } from '#app/components/pinata/pinata-page.tsx'
import { loadPinataPage } from '#app/utils/pinata/pinata.server.ts'
import { type Route } from './+types/index.ts'

export const handle: SEOHandle & { chromeless: true } = {
	chromeless: true,
	getSitemapEntries: () => null,
}

export const meta: Route.MetaFunction = ({ data }) => pinataMeta(data?.pinata)

export async function loader({ request }: Route.LoaderArgs) {
	return loadPinataPage(request, { active: true }, 'No piñata is hanging right now')
}

export default function PinataIndexRoute({ loaderData }: Route.ComponentProps) {
	return <PinataPage pinata={loaderData.pinata} />
}
